// ~/plugins/redirects.js
import { defineNuxtPlugin, addRouteMiddleware, navigateTo } from '#app';

export default defineNuxtPlugin(() => {

    const redirects = {
        'theme-admin-accounts-accountSlug-projectSlug-taskSlug': 'theme-admin-accounts-accountSlug-projectSlug-taskSlug-setup',
    };

    // now it's global!
    addRouteMiddleware(
        'central-redirects',
        (to) => {
            const fromName = to.name?.toString();
            const destName = redirects[fromName];
            if (destName && destName !== fromName) {
                return navigateTo(
                    { name: destName, params: to.params, query: to.query },
                    { replace: true }
                );
            }
        },
        { global: true }  // ← this makes it run on every navigation
    );
});
